export const ALLOWED_DOM_ID_PREFIXES = [
  "btn",
  "lnk",
  "icn",
  "txt",
  "cbo",
  "chk",
  "rad",
  "are",
  "lbl",
  "fra",
  "div",
  "sec",
  "mdl",
  "img",
] as const;

export type AllowedDomIdPrefix = (typeof ALLOWED_DOM_ID_PREFIXES)[number];

const ALLOWED_PREFIX_SET = new Set<string>(ALLOWED_DOM_ID_PREFIXES);

export function toKebabCase(input: string): string {
  if (!input) return "";

  return (
    input
      // Handle `APIKey` -> `API-Key`
      .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
      // Handle `firstName` -> `first-Name`
      .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
      // Treat underscores/spaces as word separators
      .replace(/[_\s]+/g, "-")
      .toLowerCase()
      // Strip remaining invalid chars
      .replace(/[^a-z0-9-]+/g, "")
      // Collapse repeats
      .replace(/-+/g, "-")
      // Trim
      .replace(/^-|-$/g, "")
  );
}

export function sanitizeReactIdSuffix(input: string): string {
  return (input ?? "").replace(/[^a-zA-Z0-9]+/g, "").toLowerCase();
}

export function domId(prefix: AllowedDomIdPrefix, purpose: string): string {
  const normalizedPurpose = toKebabCase(purpose);

  if (process.env.NODE_ENV !== "production") {
    if (!ALLOWED_PREFIX_SET.has(prefix)) {
      throw new Error(
        `domId(): prefix "${prefix}" is not in ALLOWED_DOM_ID_PREFIXES`,
      );
    }
    if (!normalizedPurpose) {
      throw new Error(`domId(): purpose "${purpose}" produced an empty id`);
    }
  }

  return `${prefix}-${normalizedPurpose}`;
}

